import React from "react";
import { Link } from "react-router-dom";
import styles from "./GradientCTA.module.css";

interface CallToActionProps {
  title: string;
  description: string;
  buttonText?: string;
  buttonLink?: string;
  /** Kept for backward compatibility; both variants render the same subtle brand panel. */
  variant?: "default" | "landing";
}

/**
 * Subtle brand panel
 * Renders a pink-wash panel with a 2px brand border, a title, a description and
 * one primary button.
 */
const GradientCTA: React.FC<CallToActionProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  variant = "default",
}) => {
  const isInternal = Boolean(buttonLink && buttonLink.startsWith("/"));

  return (
    <section
      className={`ui-hero-panel ui-hero-panel--subtle ${styles.panel} ${
        variant === "landing" ? styles.landing : ""
      }`}
    >
      <div className="ui-hero-copy">
        <h2>{title}</h2>
        <p>{description}</p>
        {buttonText && buttonLink && (
          isInternal ? (
            <Link to={buttonLink} className="ui-btn">
              {buttonText}
            </Link>
          ) : (
            <a href={buttonLink} className="ui-btn">
              {buttonText}
            </a>
          )
        )}
      </div>
    </section>
  );
};

export default GradientCTA;
